/**
 *
 */
import {utilModule} from '../module.js';

utilModule.directive('nsFilterExpirationYear', function() {
    return {
        require: 'ngModel',
        link: function (scope, ele) {
            //Get the year dropdown and remove the previous years
            let today = new Date();
            let thisYear = today.getFullYear() - 2000;
            ele.find('option').each(function(index,element) {
                // loop through the options and remove past years
                if (element.value.length > 0 && parseInt(element.value) < (thisYear)) {
                    element.parentNode.removeChild(element);
                }
            });
        }
    }
});
